export default (value) => value && Number(value.slice(0, -2));
